// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hvT92","checkBox":"style_checkBox__lR-fP","text":"style_text__oy5yq"};